<template lang="html">

  <div class="candidaturas-view -orientacion">

    <h2>{{$t('orientacion.solicitar_orientacion')}}</h2>

    <h3>{{$t('orientacion.solicitar_orientacion_pie')}}</h3>
    
    <div class="btn-not-container">
      <button class="btn -skull-primary" @click="navegarUrlSolicitar" >{{$t('orientacion.solicitar')}}</button>
    </div>

  </div>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  import router from '@/router';
  
  export default  {
    name: 'modulo-orientacion-solicitar',
    components : {
    },
    mounted(){
      
    },
    data(){
      return {
      }
    },
    methods: {
      ...mapActions([
      ]),
      navegarUrlSolicitar: function(){
        router.push('/orientacion/solicitar-orientacion/');
      }
    },
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles',
      }),
    },
  }
</script>

<style scoped lang="scss">

  .candidaturas-view.-orientacion{
    width: 100%;
    background-image: url("/static/img/img-stock-orientacion.png");
    background-position: top center;
    padding: 155px 0;
    background-size: cover;
    margin-top: 50px;

  }

  h2{
    font-weight: 800;
    width: 100%;
    font-size: 36px;
    color: white;
  }

  h3{
    margin: 30px 500px;
    color: white;
  }
    
  @media screen and (max-width: 1667px){
    h3{
      margin: 30px 300px;
    }
  }

  @media screen and (max-width: 1167px){
    h3{
      margin: 30px 150px;
    }
  }

  @media screen and (max-width: 767px){
    h3{
      margin: 30px 50px;
    }
  }


  @media screen and (max-width: 380px){
    h3{
      margin: 30px 10px;
    }
  }

  .-btn-not-container{
  }

  .-skull-primary{
    color: white;
    border: 2px solid white !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/views/home/modulo-orientacion-solicitar.vue